<template>
  <div class="media-item" :class="classes" @dblclick="onDoubleClick">
    <div :style="innerMediaItemStyle" class="media-item-inner"></div>
    <span @click="onDeleteClick"><i class="fas fa-times action-delete" style="z-index:2;"></i></span>
    <i class="fas fa-circle-notch fa-spin fa-3x" style="z-index:2;" v-if="item.status == 'UPLOADING'"></i>
  </div>
</template>

<script>
export default {
    props : {
        'mediaItem' : {
            type : Object,
            required: true
        }
    },

    data(){
        return {
            item : this.mediaItem
        }
    },

    emits: ['delete'],

    computed : {
        innerMediaItemStyle(){
            return {
                "background-image" : `url(${this.item.previewImageUrl})`
            }
        },
        classes() {
            let classes = [];
            if(this.item.status){
                classes.push(`status-${this.item.status.toLowerCase()}`);
            }

            return classes.join(' ');
        }
    },

    methods : {
        onDoubleClick(){
            VoterFly.UI.showMediaPopup(this.item.mediaUrl, null, null);
        },

        onDeleteClick(){
            VoterFly.UI.showModal(
                'Confirm Deletion', 
                'Are you sure you want to delete this? This cannot be undone.',
                [
                        { 
                            content: 'Yes, Delete', 
                            command: 'yes', 
                            className: 'btn-primary' 
                        },
                        {
                            content: 'Cancel',
                            command: '',
                            className: 'btn-default'
                        }
                ]
            ).then((commandName) => {
                if(commandName == 'yes'){
                    this.$emit('delete', { id: this.item.id });        
                }
            });

            
        }
    }
}
</script>

<style lang="scss">
    .media-item{
        /*
        min-height:75px;
        min-width:75px;
        background-size:cover;
        */
        cursor:pointer;
        position:relative;
        height:125px;
        width:125px;
        border-radius: 10px;
        //box-shadow: 0px 2px 3px rgba(0, 0, 0, .05);
        box-sizing: border-box; // Allows the border to be inside
        border:2px solid rgba(255, 255, 255, .6);
        background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(244,244,244,1) 100%);
        overflow: hidden;
        line-height:140px;
        text-align: center;
        color:#fff;

        .action-delete{
            border-radius: 50%;
            height:20px;
            width:20px;
            padding:4px;
            background-color:rgba(100,100,100, 0.5);;
            color:#ccc;
            position:absolute;
            top:6px;
            right:6px;
            display:inline-block;

            &:hover{
                background-color:rgba(100,100,100, 0.8);
                color:#fff;
            }
        }

        .media-item-inner{
            position:absolute;
            top:0;
            right:0;
            left:0;
            bottom:0;            
            background-size: cover;
            background-position: center;
        }

        &.status-uploading{
            opacity:0.7;
        }
    }
</style>